import { render, staticRenderFns } from "./instances.view.vue?vue&type=template&id=fac2d63e&scoped=true&"
import script from "./instances.view.vue?vue&type=script&lang=ts&"
export * from "./instances.view.vue?vue&type=script&lang=ts&"
import style0 from "./instances.view.vue?vue&type=style&index=0&id=fac2d63e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac2d63e",
  null
  
)

export default component.exports